module.exports = __webpack_public_path__ + "static/media/brazil-lab.7e9058f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/brazil-lab.png
// module id = 107
// module chunks = 0